module.exports = __webpack_public_path__ + "static/media/ipo2.8197032c.png";